<template>
	<div class="results">
		<div class="results-header">
			<span v-if="loading">
				Chargement...
			</span>
			<span v-else>
				{{ nb_results.value }} documents trouvés
			</span>
			<div class="active-filters">
				<span v-if="filters.location" @click="remove_filter('location')" class="active-filter"><span class="label">Recherche :</span> {{ filters.location.name }} <span class="remove" title="Retirer le filtre"><icon file="x" :size="16" /></span></span>
				<span v-if="filters.region" @click="remove_filter('region')" class="active-filter"><span class="label">Région :</span> {{ region_name(filters.region) }} <span class="remove" title="Retirer le filtre"><icon file="x" :size="16" /></span></span>
				<span v-if="filters.segment" @click="remove_filter('segment')" class="active-filter"><span class="label">Segment :</span> {{ filters.segment }} <span class="remove" title="Retirer le filtre"><icon file="x" :size="16" /></span></span>
				<span v-if="filters.year" @click="remove_filter('year')" class="active-filter"><span class="label">Année :</span> {{ filters.year }} <span class="remove" title="Retirer le filtre"><icon file="x" :size="16" /></span></span>
				<span v-if="filters.study_name" @click="remove_filter('study_name')" class="active-filter"><span class="label">Etude :</span> {{ filters.study_name }} <span class="remove" title="Retirer le filtre"><icon file="x" :size="16" /></span></span>
				<span v-if="filters.relance" @click="remove_filter('relance')" class="active-filter"><span class="label">Plan relance :</span> {{ relance_label }} <span class="remove" title="Retirer le filtre"><icon file="x" :size="16" /></span></span>
			</div>
		</div>
		<div class="results-content">
			<div class="list-results">
				<div class="scroll-wrap">
					<div class="scroll" v-bar >
						<div class="scroll-content" id="results-scroll">
							<row-result v-for="project in projects"
								:key="project.project_id"
								:project="project" 
								:is-active="active_project && active_project.project_id == project.project_id"
								@mouseenter.native="mouseenter_project(project)"
								@mouseleave.native="mouseleave_project(project)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex"
import RowResult from "@/components/search/row-result"
import { timeout } from "q"
import jquery from "jquery"
const $ = jquery


export default {
	name: "results",
	data: function() {
		return {

		}
	},
	computed: {
		...mapGetters(["loading", "projects", "filters", "facets", "nb_results","active_project"]), 
		relance_label :function(){
			let result = null;
			if(this.filters.relance === "1"){
				result =  "Oui";
			}else if(this.filters.relance === "2"){
				result =  "Non";
			}
			// console.log('jna resut : ',result);
			// console.log(this.filters.relance);
			return result;
		}
	},
	
	watch: {
		nb_results: function(newValue, oldValue) {
			this.$nextTick(function() {
				if ($('#results-scroll .row-result.expanded').length > 0)
					this.scroll_to_active_project()
				else
					this.scroll_to_top()
			})
		},
		active_project: function(newValue, oldValue) {
			this.$store.dispatch("set_last_action");
			if (newValue) {
				this.$nextTick(function() {
					this.scroll_to_active_project()
				})
			}
		}
	},
	methods: {
		remove_filter: function(name) {
			this.$store.dispatch("set_last_action");
			let o = {}
			o[name] = ""
			this.$store.dispatch('set_filter', o)
			this.$nextTick(function() {
				this.$store.dispatch('load_projects')
			})
		},
		scroll_to_top: function() {
			this.$store.dispatch("set_last_action");
			// $('#results-scroll').scrollTop(0)
			$('#results-scroll').animate({ scrollTop: 0 }, 500)
		},
		scroll_to_active_project: function() {
			this.$store.dispatch("set_last_action");
			let top = $('#results-scroll .row-result.expanded').get(0).offsetTop
			$('#results-scroll').animate({ scrollTop: top }, 500)
		},
		region_name(reg_id) {
			this.$store.dispatch("set_last_action");
			if(this.facets && this.facets.regions[reg_id]) {
				return this.facets.regions[reg_id].region_name;
			} else {
				return null;
			}
		},
		mouseenter_project: function(project) {
			this.$store.dispatch("set_last_action");
			if (project && project.project_id) {
				$('#map').find('#pin-project-' + project.project_id).addClass('active')
			}
		},
		mouseleave_project: function(project) {
			this.$store.dispatch("set_last_action");
			$('#map .map-icon').removeClass('active')
		}
	},
	mounted: function() {
		let self = this

		if (this.active_project) {
			this.$nextTick(function() {
				this.scroll_to_active_project()
			})
		}
	},
	components: { RowResult }
}
</script>

<style lang="stylus">
@import '../../assets/css/app'

.results
	box-shadow -2px 0 4px alpha(#333, 15%)
	z-index 1000
	.results-header
		height: 64px
		padding: 0 24px
		border-bottom: 2px solid #eee
		font-weight: 500
		font-size: 1.5rem
		line-height: @height

		.active-filters
			position: absolute
			right: 24px
			top: 16px
			height: 32px
			line-height: @height
			font-size: 1.3rem

			.active-filter
				display: inline-block
				margin 0 0 0 8px
				padding: 0 40px 0 16px
				background-color: #eee
				border-radius radius
				cursor pointer
				&:hover
					.remove
						background-color red
						color #fff
				.label
					font-weight 400
					color #999
				.remove
					position absolute
					right 0
					top 0
					width 32px
					background-color #ddd
					text-align center
					border-top-right-radius radius
					border-bottom-right-radius radius

	.results-content
		height: 100%
		.list-results
			height: calc(100% - 64px)
</style>
